import DataGrid, { Column, Grouping, GroupPanel, Pager, Paging, SearchPanel } from 'devextreme-react/data-grid';
import { Chart, Series, Label, CommonSeriesSettings, ArgumentAxis } from 'devextreme-react/chart';
import PieChart, { Legend, Tooltip, Format, Connector, Export, } from 'devextreme-react/pie-chart';
import TreeMap from 'devextreme-react/tree-map';
import { TonKhoAVPSelector, getInStock, getTonKhoBatch } from '../../store/reducers/Report/TonKhoAVP'
import { useSelector, useDispatch } from 'react-redux'
import 'devextreme/dist/css/dx.light.css';
import { useEffect, useContext, useState } from "react";
import { Spin, Row, Col, Card } from 'antd';
import { ConstContext } from '../../store/context/constContext'

const pageSizes = [10, 20, 50, 100, 500];

function StockDashboard() {
    const {
        isMobile,
    } = useContext(ConstContext)
    const dispatch = useDispatch()
    const TonKhoAVPSelectors = useSelector(TonKhoAVPSelector)

    useEffect(() => {
        dispatch(getInStock())
    }, [])
    console.log('24', TonKhoAVPSelectors.InStockByPro2_4)
    console.log('2_4str', JSON.stringify(TonKhoAVPSelectors.InStockByPro2_4))
    return (
        <>
            <Row gutter={16} style={{ justifyContent: 'center' }}>
                <Col xs={24} sm={24} md={24} lg={12} xl={9} xxl={12} >
                    <Card>
                        <Chart id={"chart"}
                            dataSource={TonKhoAVPSelectors.InStockByPro2}
                            rotated={false} >
                            <CommonSeriesSettings argumentField="U_Pro_2" />
                            <ArgumentAxis >
                                <Label displayMode="rotate" />
                            </ArgumentAxis>
                            <Series valueField={"Total"}
                                name={isMobile ? " " : "Tồn kho theo loại giấy"}
                                type={"bar"}
                                color={"#edb02b"} >
                                <Label displayMode="rotate" visible={false} format="###,###,###"></Label>
                            </Series>
                            <Tooltip enabled={true}
                                customizeTooltip={customizeTooltipBarChart}>
                                <Format type="###,###,###" />
                            </Tooltip>
                            <Export enabled={false} />
                        </Chart>
                    </Card>
                </Col>
                <Col xs={24} sm={24} md={24} lg={12} xl={9} xxl={12} >
                    <Card>
                        <Chart id={"chart"}
                            dataSource={TonKhoAVPSelectors.InStockByPro4}
                            rotated={false} >
                            <CommonSeriesSettings argumentField="U_Pro_4" />
                            <ArgumentAxis >
                                <Label displayMode="rotate" />
                            </ArgumentAxis>
                            <Series valueField={"Total"}
                                name={isMobile ? " " : "Tồn kho theo nhãn hàng"}
                                type={"bar"}
                                color={"#275de6"} >
                                <Label displayMode="rotate" visible={false} format="###,###,###"></Label>
                            </Series>
                            <Tooltip enabled={true}
                                customizeTooltip={customizeTooltipBarChartPro4}>
                                <Format type="###,###,###" />
                            </Tooltip>
                            <Export enabled={false} />
                        </Chart>
                    </Card>
                </Col>
            </Row>
            <Row gutter={32} style={{ justifyContent: 'center' }}>
                <Col xs={48} sm={48} md={48} lg={24} xl={18} xxl={24} >
                    <TreeMap
                        id="treemap"
                        dataSource={TonKhoAVPSelectors.InStockByPro2_4}
                        title="Phân bổ nhãn hàng theo loại hàng"
                    >
                        <Tooltip
                            enabled={true}
                            format="thousands"
                            customizeTooltip={customizeTooltipTreeMapPro2_4}
                        />
                    </TreeMap>
                </Col>
            </Row>
        </>
    );
    function customizeTooltipBarChart(pointInfo) {
        return {
            text: `${pointInfo.point.data.U_Pro_2} <br/> <br/> ${pointInfo.valueText}`,
        };
    }
    function customizeTooltipBarChartPro4(pointInfo) {
        return {
            text: `${pointInfo.point.data.U_Pro_4} <br/> <br/> ${pointInfo.valueText}`,
        };
    }
    function customizeTooltipTreeMapPro2_4(arg) {
        const { data } = arg.node;

        return {
            text: arg.node.isLeaf()
                ? `<span class="city">${data.name}</span><br/>Quantity(Kg): ${arg.valueText}`
                : null,
        };
    }
}

export default StockDashboard;